import { isNil } from 'ramda'

import type { Category } from '@twisto/api-cms'

type CrumbData = {
  name: string
  path: string
}

export const getCrumbsFromCategories = (
  attributes: Category | undefined
): CrumbData[] => {
  if (isNil(attributes) || isNil(attributes.name)) {
    return []
  }

  return [
    ...getCrumbsFromCategories(attributes.parent as Category),
    {
      name: attributes.name,
      path: attributes.path ?? '',
    },
  ]
}
